import { useState } from 'react';
import { Row, Col, Button, Form } from 'reactstrap';
import {
  InputDateControlled,
  ValidationErrors,
  RequiredRule,
  DateFormatRule,
  validateFields,
  validateField,
  useTranslator,
} from '@front-activerse/common-components';
import PropTypes, { string } from 'prop-types';

import { createDateObject, formatIsoDate } from '@front-activerse/common-components';

const ShoppingListSearch = ({ handlePeriodChange, period, setPeriod }) => {
  const [errors, setErrors] = useState(new ValidationErrors());
  const { t } = useTranslator();

  const validationRules = {
    start: [new RequiredRule({ translator: t }), new DateFormatRule({ translator: t })],
    end: [new RequiredRule({ translator: t }), new DateFormatRule({ translator: t })],
  };

  const handleSubmit = (event) => {
    event.preventDefault();

    const frontEndErrors = validateFields(validationRules, period, t);

    if (frontEndErrors.length === 0) {
      const newPeriod = {
        start: formatIsoDate(createDateObject(period.start)),
        end: formatIsoDate(createDateObject(period.end)),
      };
      handlePeriodChange(newPeriod);
    }
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;

    setPeriod((prev) => ({
      ...prev,
      [name]: value,
    }));

    if (validationRules[name]) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        details: validateField(name, value, validationRules[name], { errors: prevErrors }),
      }));
    }
  };

  return (
    <div className="shopping-list-search">
      <h3 className="title-medium semi-bold text-center pt-m">
        {t('shoppingList.dateRange.title')}
      </h3>
      <Form onSubmit={handleSubmit} noValidate data-test="search-form">
        <Row className="gx-0">
          <Col xs="6" className="pe-1">
            <div className='className="mb-m"'>
              <InputDateControlled
                name="start"
                value={period.start}
                errors={errors}
                handleChange={handleInputChange}
                data-test="start-input"
              />
            </div>
          </Col>
          <Col xs="6" className="ps-1">
            <div className="mb-m">
              <InputDateControlled
                name="end"
                value={period.end}
                errors={errors}
                handleChange={handleInputChange}
                data-test="end-input"
              />
            </div>
          </Col>
        </Row>

        <Button color="primary" className="w-100 mb-xl">
          {t('shoppingList.dateRange.button')}
        </Button>
      </Form>
      <hr className="m-0" />
    </div>
  );
};

ShoppingListSearch.propTypes = {
  period: PropTypes.shape({
    start: string.isRequired,
    end: string.isRequired,
  }).isRequired,
  handlePeriodChange: PropTypes.func.isRequired,
  setPeriod: PropTypes.func.isRequired,
};

export default ShoppingListSearch;
